import ApiCityCountry from 'types/api/CityCountry';

import Model from 'models/Model';

export default class CityCountry implements Model {
    id: string;
    name: string;
    slug: string;

    constructor(data: ApiCityCountry) {
        this.id = data.id;
        this.name = data.name;
        this.slug = data.slug;
    }
}